import { useMemo } from 'react';

import { Card } from '@/components/ui/card';
import { ColumnChart } from '@/features/dashboard-charts';
import { getExportOptions } from '@/features/chart-export/model/utils';
import type { ChartData } from '@/entities/dashboard';

interface ActivityChartProps {
  data?: ChartData;
  isLoading: boolean;
}

export function ActivityChart({ data, isLoading }: ActivityChartProps) {
  const exportOptions = useMemo(() => getExportOptions('service-users'), []);

  return (
    <Card className="p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold">Service Activity by Partner</h3>
        <p className="text-sm text-muted-foreground">
          Breakdown of received, released, and dispatched volumes across service partners
        </p>
      </div>

      <ColumnChart data={data} height={400} loading={isLoading} showExport exportOptions={exportOptions} />
    </Card>
  );
}
